<template>
    <div>
        <v-card>
            <v-img height="80" src="@/assets/images/fondo1.png">
                <v-row class="pa-4" align="center" justify="center">
                    <v-col fluid>
                        <v-list-item-avatar color="cyan" size="40" class="ma-0">
                            <v-icon size="30">auto_stories</v-icon>
                        </v-list-item-avatar>
                        <span class="headline black--text ma-4">Itinerario</span>
                    </v-col>
                </v-row>
            </v-img>
        </v-card>
        <v-row>
            <v-col cols="6">
                <v-card>
                    <v-card-title>
                        <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                            :items="ssPriServiciosIngreso"  item-value="IdServicio" item-text="Descripcion2"
                            filled prepend-inner-icon="bookmark" clearable style="top:15px"></v-autocomplete>
                        <v-btn @click.prevent="fuNew" color="success" x-large><v-icon large left>add</v-icon> Agregar</v-btn>
                    </v-card-title>
                    <v-data-table :headers="dTable.headers" :items="dDdcbitinerario" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
                        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outlined border="top">No hay registros para mostrar.</v-alert></template>
                        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outlined border="top">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
                        <template v-slot:[`item.actions`]="{ item }">
                            <v-btn @click="fuEdit(item.IdItinerario)" icon><v-icon>edit</v-icon></v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
            <v-col cols="6">
                <DcbItinerarioAdd v-show="dDcbItinerarioShow" :pfuNew="fuNew" :pIdServicio="dIdServicio" :pLoad="fuLoad" :pIdItinerario="dIdItinerario"/>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import DcbItinerarioAdd from '@/components/DCB/DcbItinerarioAdd.vue';

export default {
    name: 'DcbItinerario',
    components: {DcbItinerarioAdd},
    mounted(){
        this.fuLoad();
    },
    data: () => ({
        dDdcbitinerario: [],
        dTable: {
            headers: [
                {value: 'actions', text: '...', sortable: false},
                {value: 'IdItinerario', text: 'IdItinerario', align: ' d-none'},
                {value: 'admconfigperiodo.Anio_Periodo', text: 'Periodo'},
                {value: 'Curricula', text: 'Curricula'},
                {value: 'DocumentoAutorizacion', text: 'DocumentoAutorizacion'},
                {value: 'priservicio.Iniciales', text: 'P.E.'},
            ],
            loading: false,
            search: 'CON',
        },
        dIdServicio: 2,
        dIdItinerario: null,
        dDcbItinerarioShow:false,
    }),
    computed: {
        ...mapState(['ssPriServiciosIngreso']),
    },
    watch: {
        'dIdServicio' (val) {
            console.log(val);
            if(val == null)
                this.dTable.search = '';
            else
                this.dTable.search = (this.ssPriServiciosIngreso.find(({IdServicio}) => IdServicio === val)).Iniciales;
        }
    },
    methods: {
        async fuLoad() {
            this.dLoading = true;
            this.dDdcbitinerario = [];
            try {
                const response = await this.$apollo.query({
                    query: gql` query dcbitinerarioByActivo{
                        dcbitinerarioByActivo(Activo:1){
                            IdItinerario
                            IdServicio
                            Curricula
                            DocumentoAutorizacion
                            priservicio{
                                Iniciales
                            }
                            admconfigperiodo{
                                Anio_Periodo
                            }
                        }
                    }`,fetchPolicy: 'no-cache',
                })
                this.dDdcbitinerario = response.data.dcbitinerarioByActivo;
                console.log(this.dDdcbitinerario);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de conexion.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        fuNew() {
            this.dIdItinerario = null;
            this.dDcbItinerarioShow = true;
        },
        fuEdit(id){
            this.dIdItinerario = parseInt(id);
            this.dDcbItinerarioShow = true;
        }
    }
}
</script>